import { ApiQuery, SortDirections } from "../filters/types";
import { MeasureColumns, MeasureUnit } from "./types";

// // // //

export const DEFAULT_MEASURE_LIST_QUERY: ApiQuery = {
    sort: {
        direction: SortDirections.asc,
        field: MeasureColumns.name,
    },
    pagination: {
        page: 1,
        perPage: 150, // Request all measures at once (no pagination)
    },
};

// // // //

export const MEASURE_UNIT_LABELS: Record<MeasureUnit, string> = {
    [MeasureUnit.dollar]: "Dollar",
    [MeasureUnit.percent]: "Percent",
    [MeasureUnit.token]: "Token",
    [MeasureUnit.shares]: "Shares",
    [MeasureUnit.address]: "Address",
    [MeasureUnit.loan]: "Loan",
    [MeasureUnit.trades]: "Trades",
    [MeasureUnit.transfers]: "Transfers",
    [MeasureUnit.year]: "Year",
    [MeasureUnit.id]: "ID",
    [MeasureUnit.ratio]: "Ratio",
    [MeasureUnit.x]: "N/A",
    [MeasureUnit.enum]: "Status",
};
